import React from 'react';
import { STATS, TESTIMONIALS } from '../mock/mock';
import { Quote, Star } from 'lucide-react';

export default function Social() {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-neutral-50">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        {/* Stats strip */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-20">
          {STATS.map((s) => (
            <div key={s.label} className="text-center md:text-left">
              <div className="font-display text-4xl lg:text-5xl font-bold text-neutral-900 tracking-tight">{s.value}</div>
              <div className="mt-1 text-sm text-neutral-500">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <div key={i} className="relative bg-white rounded-2xl border border-neutral-200 p-6 hover:shadow-lg transition-shadow">
              <Quote className="absolute top-5 right-5 w-6 h-6 text-neutral-200" />
              <div className="flex items-center gap-1 mb-3">
                {[0, 1, 2, 3, 4].map((s) => (
                  <Star key={s} className="w-4 h-4 fill-amber-400 text-amber-400" />
                ))}
              </div>
              <p className="text-neutral-800 leading-relaxed">“{t.quote}”</p>
              <div className="mt-5 flex items-center gap-3">
                <div className={`w-10 h-10 rounded-full bg-gradient-to-br ${
                  ['from-amber-200 to-rose-300', 'from-sky-200 to-indigo-300', 'from-emerald-200 to-teal-300'][i % 3]
                }`} />
                <div>
                  <div className="text-sm font-semibold text-neutral-900">{t.name}</div>
                  <div className="text-xs text-neutral-500">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
